import {InitPage} from "../../index";

declare var printBolPath;
declare var client_code;
declare var store_code;
declare var soProcessId;

class History {
  constructor() {
    $('.radios-field').on('click', function () {
      $('#submit-print_action-form').val($(this).attr('data-val'));
    });

    $('#submit-print_action-form').on('click', function () {
      $("#print-actions-modal").modal('hide');

      var selectedPrinter = $('#printer').val();
      var action = $("input[name='action_type']:checked").val();
      const printCopies = $('#input_copies').val();
      const copiesParam = '&copies=' + printCopies

      switch (action) {
        case 'print_bol':
          window.location.href = printBolPath + '&printer=' + selectedPrinter + copiesParam;
          break;

          case 'preview_bol':
            window.open('/' + client_code + '/' + store_code + '/api/v1/printing/so-zone-cover/' + selectedPrinter + '.pdf?' + 'soProcessId=' + soProcessId + copiesParam, '_blank');
            break;

          case 'print_pallet_lic':
            $('#action_form').submit();
            break;

          case 'preview_pallet_lic':
            window.open('/' + client_code + '/' + store_code + '/api/v1/printing/so-zone-pallet-license/' + selectedPrinter + '.pdf?' + 'soProcessId=' + soProcessId + copiesParam, '_blank');
            break;

          case 'print_invoice':
            window.location.href = `/${client_code}/${store_code}/manufacturing/so_to_zone_processes/print_invoice?id=${soProcessId}&printer=${selectedPrinter}${copiesParam}`;
            break;

          case 'preview_invoice':
            window.open(`/${client_code}/${store_code}/api/v1/printing/so-zone-invoice/${selectedPrinter}.pdf?soProcessId=${soProcessId}${copiesParam}`, '_blank');
            break;

          case 'print_packing_list':
            window.location.href = `/${client_code}/${store_code}/manufacturing/so_to_zone_processes/print_packing_list?id=${soProcessId}&printer=${selectedPrinter}${copiesParam}`;
            break;

          case 'preview_packing_list':
            window.open(`/${client_code}/${store_code}/api/v1/printing/so-zone-packing-list/${selectedPrinter}.pdf?soProcessId=${soProcessId}${copiesParam}`, '_blank');
            break;

          default:
            break;
      }
    });


    $('document').ready(function () {
      $('#print_actions_btn').on('click', function () {
        $('#print_bol').prop('checked', true);
        $('#submit-print_action-form').val('Print');
        $("#print-actions-modal").modal('show');
      });

      // @ts-ignore: Added globaly
      $('#invoiced_at').daterangepicker({
        autoUpdateInput: false,
        "singleDatePicker": true,
        "timePicker": true,
        defaultDate: null,
        startDate: document.getElementById('edit-invoice-date')?.previousSibling?.textContent.trim() || new Date(),
        locale: {
          format: 'MM/DD/YYYY hh:mm A'
        }
      }).on("apply.daterangepicker", function (e, picker) {
        picker.element.val(picker.startDate.format(picker.locale.format));
      });

      $('#invoiced-at-btn').on('click', function (e) {
        e.preventDefault();
        $('#invoiced_at').click();
      });

      $('#edit-invoice-date').on('click', function() {
        const datetime = this.previousSibling.textContent.trim();
        $('#invoiced_at').val(datetime);
        $("#invoice-date-dialog").modal('show');
      })
    });
  }
}

export function LoadPage() {

  InitPage("so_to_zone_processes history", () => {
    const history = new History();
  });

  InitPage("so_to_zone_processes pending_shipment", () => {
    const history = new History();
  });

  InitPage("so_to_zone_processes pending_invoice", () => {
    const history = new History();
  });
}
